module.exports = __webpack_public_path__ + "static/img/rank_198.fe5b8a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_198.png
// module id = 0qyK
// module chunks = 0